/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0179ace6db90174fb1e33ede0463bdef>>
 * @codegenCommand yarn build-glyphs
 */
import React from 'react';
import IconComponent from '@atlaskit/icon/core/changes';
import ObjectBase from '../object-base';
export default function ChangesObject(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Changes' : _ref$label,
    size = _ref.size,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(ObjectBase, {
    label: label,
    size: size,
    testId: testId,
    icon: IconComponent,
    color: "var(--ds-icon-accent-yellow, #B38600)"
  });
}